import { render, staticRenderFns } from "./MarketingCampaignDetails.vue?vue&type=template&id=4dbd0efe&scoped=true&"
import script from "./MarketingCampaignDetails.vue?vue&type=script&lang=js&"
export * from "./MarketingCampaignDetails.vue?vue&type=script&lang=js&"
import style0 from "./MarketingCampaignDetails.vue?vue&type=style&index=0&id=4dbd0efe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbd0efe",
  null
  
)

export default component.exports